module.exports = __webpack_public_path__ + "static/media/6c88cb53.jpg";